import React, { Component } from "react";
import { NavLink, withRouter } from 'react-router-dom';
import { BoxDanger, MnemoLoading, SupportoTecnico, Title } from "components/misc";
import { learningService, lessonSectionService, networkErrorHelper } from "libs";
import { Icon } from "design-react-kit";
import { COMPANY, ROUTES } from "const";

class CFUALLExamReservation extends Component {

    state = {
        loading: true,
        loadingError: false,
        course: 0,
        userCourse: 0,
        rCode: '',
        analyticsOK: false,

        lessons: [],
        sections: [],
        sectionsGroup: [],
        analytics: [],
        lessonCreditRecognition: [],
    };

    goBack() {
        window.history.back();
    }

    componentDidMount() {

        const { rCode } = this.props.match.params;
        this.loadRemote(rCode);
    }

    checkAnalytics(course, sections, analytics) {

        let analyticsOK = true;

        // verify sections not included in analytics 
        for (let i = 0; i < sections.length; i++) {

            const section = sections[i];
            if (!(section.code === 'ATI' || section.code === 'ATD')) {
                const analyticCurrent = analytics.filter(a => a.section === section.code);
                if (analyticCurrent && analyticCurrent.length > 0) {

                    // verify analytics
                    for (let i = 0; i < analyticCurrent.length; i++) {

                        const analytic = analyticCurrent[i];

                        let percent = (analytic.minutes * 1.0) / section.totalMinutes;
                        if (percent < 0.7) {
                            console.log('section not completed', section.code, 'percent', percent);
                            analyticsOK = false;
                            break;
                        }
                    }
                }
                else {
                    console.log('section without analytic', section.code);
                    analyticsOK = false;
                    break;
                }
            }
        }


        if (analyticsOK) {
            // tirocicnio check
            if (course.courseType === 'CORSI36ALL5') {

                let tirocinioMinutes = 0;
                let tirocinioTotal60 = 9360; // 36ALL5 36 ore tirocinio indiretto + 120 ore tirocinio diretto
                const analyticsATI = analytics.find(a => a.section === 'ATI');
                const analyticsATD = analytics.find(a => a.section === 'ATD');
                if (analyticsATI) {
                    tirocinioMinutes += parseInt(analyticsATI.minutes);
                }
                if (analyticsATD) {
                    tirocinioMinutes += parseInt(analyticsATD.minutes);
                }
                let percent = tirocinioMinutes / tirocinioTotal60;
                if (percent < 0.7) {
                    console.log('tirocinio not completed', 'percent', percent);
                    analyticsOK = false;
                }

            } else if (course.courseType === 'ABILITAZIONI60CFU') {

                let tirocinioMinutes = 0;
                let tirocinioTotal60 = 14400; // 60ALL1 60 ore tirocinio indiretto + 180 ore tirocinio diretto
                // trova le section 'ATI' e 'ATD' e somma i minuti
                const analyticsATI = analytics.find(a => a.section === 'ATI');
                const analyticsATD = analytics.find(a => a.section === 'ATD');
                if (analyticsATI) {
                    tirocinioMinutes += parseInt(analyticsATI.minutes);
                }
                if (analyticsATD) {
                    tirocinioMinutes += parseInt(analyticsATD.minutes);
                }
                let percent = tirocinioMinutes / tirocinioTotal60;
                if (percent < 0.7) {
                    console.log('tirocinio not completed', 'percent', percent);
                    analyticsOK = false;
                }
            } else {
                // no tirocinio: trova il section 'ATI' 
                const analyticsATI = analytics.find(a => a.section === 'ATI');
                if (analyticsATI) {
                    let percent = analyticsATI.minutes / analyticsATI.total;
                    if (percent < 0.7) {
                        console.log('ATI not completed', 'percent', percent);
                        analyticsOK = false;
                    }
                } else {
                    console.log('ATI not found', 'percent', 0);
                    analyticsOK = false;
                }

            }
        }

        this.setState({ analyticsOK });
    }

    checkAnalyticsGroup(sectionsGroup) {

        let analyticsOK = true;

        // iterate for each section group anche check if there is a percent < 0.7
        for (let i = 0; i < sectionsGroup.length; i++) {
            const group = sectionsGroup[i];
            if (group.percent < 0.7) {
                console.log('group not completed', group.code, 'percent', group.percent);
                analyticsOK = false;
                break;
            }
        }

        this.setState({ analyticsOK });

    }

    loadRemote(rCode) {

        learningService
            .courseDashboard(rCode)
            .then(({ data }) => {

                const { course, userCourse } = data.payload;
                this.setState({ course, userCourse, rCode });

                // load analytics
                lessonSectionService
                    .MySchedule(course.id, rCode)
                    .then(({ data }) => {

                        const { lessons, sections, sectionsGroup, analytics, lessonCreditRecognition } = data.payload;

                        this.setState({
                            loading: false,
                            lessons,
                            sections,
                            sectionsGroup,
                            analytics,
                            lessonCreditRecognition: lessonCreditRecognition || [],
                        });

                        // check Analytics                       
                        if (course.instituteCompany === COMPANY.UNITELMA) {
                            this.checkAnalyticsGroup(sectionsGroup);
                        } else {
                            this.checkAnalytics(course, sections, analytics);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        if (!networkErrorHelper.is404(error)) {
                            console.log(error);
                            networkErrorHelper.notify(error);
                        }

                        this.setState({
                            loading: false,
                            ladingError: true,
                        });
                    });
            })
            .catch(error => {

                if (!networkErrorHelper.is404(error)) {
                    networkErrorHelper.notify(error);
                }

                this.setState({ loading: false, loadingError: true });
            });
    }

    renderIFrame() {

        const { course, rCode } = this.state;
        const aaURL = course.aa.toString().slice(-2);
        let src = process.env.REACT_APP_CRM_URL.replace('[yearTag]', aaURL)
            + 'moodleExam/index/rCode/' + rCode;
        let height = '10500px';

        return (
            <>
                <div>
                    <embed src={src} width="99%" height={height} />
                </div>
            </>
        );
    }

    render() {

        const { loading, loadingError, rCode, analyticsOK } = this.state;
        if (loading) return (<MnemoLoading></MnemoLoading>);

        if (loadingError) {
            return (<BoxDanger className="mt-4">
                Si è verificato un errore durante il caricamento della pagina,
                <br /><SupportoTecnico />
            </BoxDanger>);
        }

        if (!analyticsOK) {
            return (<BoxDanger className="mt-4">
                Per procedere alla prenotazione della prova finale, ai sensi della normativa vigente, sarà necessaria una percentuale minima di presenza alle attività formative pari al 70%.<br />
                La invitiamo a consultare la sezione dedicata selezionando la voce “Attività formative” e prendere visione delle “Modalità di svolgimento della prova finale” presenti nella sezione Avvisi importanti.
            </BoxDanger>);
        }

        const info = this.renderIFrame();

        return (<>
            <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`} className="mx-5 btn btn-outline-primary float-right"><Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO</NavLink>
            <Title >Prenotazione Prova Finale</Title>
            {info}
        </>)
    }
}

export default withRouter(CFUALLExamReservation);